<template>
  <div class="nutrients" >
    <HeadLine>
      {{$ml.get('Nutrients')}}
    </HeadLine>
    <table class="th-table">
      <tr class="head">
        <td>{{$ml.get('Element')}}</td>
        <td v-if="section.data.isExtensions">{{$ml.get('Extraction Method')}}</td>
        <td v-if="section.data.isExtensions">{{$ml.get('Test Result')}}</td>
        <td>{{$ml.get('Interpretation')}}</td>
      </tr>
      <tr v-for="n in section.data.data">
        <template v-if="n.ext && n.type != 'NNH2'">
          <td>{{ n.type }}</td>
          <td v-if="section.data.isExtensions">{{ $ml.get(n.extName) }}</td>
          <td v-if="section.data.isExtensions">
            <template v-if="n.value">
              {{ parseFloat(n.value).toFixed(2) }} {{$ml.get('ppm')}}
            </template>
            <template v-else>
              -
            </template>
          </td>
          <td 
            class="interpretation"
            :style="{
              color: interpretationChart(n.interpretation)
            }"
          >{{ $ml.get(n.interpretation) }}
          </td>
        </template>
      </tr>
    </table>
  </div>
</template>

<script>
import HeadLine from './../common/HeadLine';
export default {
  methods: {
    interpretationChart(lvl) {
      switch(lvl) {
        case 'Excessive': 
          return '#EC5A60';
        case 'High': 
          return '#F2B14E';
        case 'Adequate': 
          return '#A7B975';
        case 'Low': 
          return '#5EC19B';
        
      }
    }
  },
  computed: {
    section() {
      console.log(this.$root.data.mediaAnalysis);
      return this.$root.data.mediaAnalysis;
    },
    
  },
  components: {
    HeadLine,
  },
}
</script>

<style lang="scss" scoped>

.nutrients {
  .interpretation {
    font-weight: bold;
  }
}

</style>